import React from 'react'

const path1 = `M25.6 17.0667C20.8853 17.0667 17.0667 20.8853 17.0667 25.6V102.4C17.0667 107.115 20.8853 110.933 25.6 110.933H102.4C107.115 110.933 110.933 107.115 110.933 102.4V25.6C110.933 20.8853 107.115 17.0667 102.4 17.0667H25.6ZM51.2 29.8667H76.8C81.5147 29.8667 85.3333 33.6853 85.3333 38.4V89.6C85.3333 94.3147 81.5147 98.1333 76.8 98.1333H51.2C46.4853 98.1333 42.6667 94.3147 42.6667 89.6V38.4C42.6667 33.6853 46.4853 29.8667 51.2 29.8667Z`
const path2 = `M51.25 66.5C51.25 65.1193 52.3693 64 53.75 64H74.25C75.6307 64 76.75 65.1193 76.75 66.5V87C76.75 88.3807 75.6307 89.5 74.25 89.5H53.75C52.3693 89.5 51.25 88.3807 51.25 87V66.5Z`

const SwitchOffIcon = ({ size, color }: { size: number; color: string }) => (
  <svg width={size} height={size} viewBox='0 0 128 128' fill='none'>
    <path d={path1} fill={color} fillOpacity={0.5} />
    <path d={path2} fill={color} />
  </svg>
)

export default SwitchOffIcon
